import React from "react";

const BackgroundOpacity = (props) => {
  const { customFunc } = props;

  return (
    <div
      className="fixed top-20 bottom-0 left-0 right-0 bg-gray-900 opacity-70 z-10"
      onClick={customFunc}
    ></div>
  );
};

export default BackgroundOpacity;
